import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import CodeView from '../CodeView'

import styles from './styles'
import { Typography } from '@material-ui/core'

const EmbedWidget = ({ classes, config }) => {
  return (
    <div className={classes.root}>
      <div>
        <Typography fontSize="14px" fontWeight={500}>
          Embed Widget
        </Typography>
        <Typography fontSize="14px" fontWeight={400} color="#637381">
          Customize your embed widget settings.
        </Typography>
      </div>
      <CodeView
        label="HTML"
        buttonLabel="Copy HTML code"
        widgetType="embed"
        config={config}
      />
      <CodeView
        label="JavaScript"
        buttonLabel="Copy JavaScript code"
        widgetType="embed"
        config={config}
      />
    </div>
  )
}

export default withStyles(styles)(EmbedWidget)
